import React from 'react';
import classnames from 'classnames';

import { generateRandomKey } from '../../utils';

import styles from './locationList.module.css';

const LocationList = (props) => {
  const { locationList, isCity } = props;
  let headerText = 'Best companies to work for in each state';
  if (isCity) {
    headerText = 'Best companies to work for in major cities';
  }
  return (
    <div className={`${styles['best-companies-in-section']} pt-80 container`}>
      <p>{headerText}</p>
      <div className={`${styles['best-companies-in-wrapper']} col-12 no-side-padding`}>
        <div className="best-companies-in-container">
          {locationList &&
            locationList.map((item) => (
              <div
                className={`${styles['item-container']} no-side-padding`}
                key={generateRandomKey()}
              >
                <a href={item.link}>
                  <div
                    className={classnames(styles['item-icon'], styles[item.class], item.class)}
                  />
                </a>
                <div className={styles['item-text']}>
                  <a className="list-link" href={item.link}>
                    {item.name}
                  </a>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default LocationList;
